import { render, staticRenderFns } from "./RoleManager.vue?vue&type=template&id=b39ac164&scoped=true"
import script from "./RoleManager.vue?vue&type=script&lang=js"
export * from "./RoleManager.vue?vue&type=script&lang=js"
import style0 from "./RoleManager.vue?vue&type=style&index=0&id=b39ac164&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39ac164",
  null
  
)

export default component.exports